
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19.178 1.154a1.667 1.667 0 00-2.357 0L.155 17.821l2.357 2.357 2.155-2.155v14.31A3.333 3.333 0 008 35.666h20a3.333 3.333 0 003.333-3.333v-14.31l2.155 2.155 2.357-2.357L19.178 1.154zM28 14.69l-10-10-10 10v17.643h20V14.69zm-11.667.976v5h-5v3.333h5v5h3.334v-5h5v-3.333h-5v-5h-3.334z","fill":"#0037FF"}})])
          )
        }
      }
    